<template>
    <div class="home" :style="`height:${height}px`">
        <div style="display: flex;align-items: center;justify-content: space-between;">
            <div class="home_left">
                <div class="top_box">
                    <div class="header">
                        <div class="header_top">
                            <div class="header_top_left">
                                <img src="../assets/img/home/tx.png" alt="">
                                <div class="user">
                                    <h5>{{ getTimeState() }}，{{ userName }}({{ opmJob }})！</h5>
                                    <p>{{ userDep }}</p>
                                </div>
                            </div>
                            <div class="header_top_right">
                                <span class="time">{{ $moment(time).format("HH:mm:ss") }}</span>
                                <div class="week">
                                    <p>{{ $moment(time).format("YYYY年MM月DD日") }} </p>
                                    <p>{{ timeWeek($moment(time).format("dddd")) }}</p>
                                </div>
                            </div>
                        </div>
                        <ul class="header_bottom">
                            <li v-for="(item, index) in backlogList" :key="index" @click="clickTask(index)">
                                <div>
                                    <p>{{ item.title }}</p>
                                    <p>{{ item.num }} <i style="font-style: normal;font-size: 0.9vw;">单</i></p>
                                </div>
                                <i :class="`${item.icon} icons`"></i>
                            </li>
                        </ul>
                    </div>
                </div>
                <div class="bottom_box">
                    <div class="content_left">
                        <div class="content_left_top">
                            <div class="block">
                                <span></span>
                                <h3 style="width: 100%;">预警中心 <i
                                        :style="`transform: rotateZ(${rotateZ}deg);transition: all 0.5s; float: right; font-size: 22px; cursor: pointer;`"
                                        class="el-icon-refresh" @click="queryAllNum"></i></h3>
                            </div>
                            <ul>
                                <!-- 上层 -->
                                <template>
                                    <div v-for="(item, index) in earlyWarning" :key="index"
                                        style="display: flex;align-items: center;">
                                        <li @click="clickWarning(index)" style="cursor: pointer;">
                                            <el-tooltip v-if="item.toolTip" effect="dark" :content="item.toolTip"
                                                placement="top">
                                                <div slot="content" style="max-width: 300px; ">
                                                    {{ item.toolTip }}
                                                </div>
                                                <h4 class="title_name">
                                                    <span>{{ item.title }}<i class="el-icon-question"></i></span>

                                                </h4>
                                            </el-tooltip>
                                            <h4 v-else class="title_name">
                                                <span>{{ item.title }}</span>
                                            </h4>

                                            <h4 class="num">{{ item.num }} <i
                                                    style="font-style: normal;font-size: 0.75vw;">条</i>
                                            </h4>
                                            <p class="rate">

                                                <span v-html="item.content"> </span>

                                            </p>
                                        </li>
                                        <el-divider v-if="index != 3 && index != 7" direction="vertical"
                                            class="direction_height"></el-divider>
                                    </div>
                                </template>
                            </ul>
                        </div>
                        <div class="content_left_bottom"
                            :style="`display: flex;justify-content: space-between;height:${content_left_bottom}px`">
                            <table border="1" v-for="(item, index) in timeoutList" :key="index">
                                <thead>
                                    <tr>
                                        <th colspan="4">超时项目</th>
                                        <th>时限</th>
                                        <th>条数</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr v-for="(val, key) in item.children" :key="key">
                                        <td colspan="4"><span @click="earlySee(val.warnPath)">{{ val.warnName }}</span>
                                        </td>
                                        <td>{{ val.warnParam }}</td>
                                        <td>{{ val.count }}</td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </div>
            <div class="right">
                <div class="content_top" :style="`height:${content_top_height}px`">
                    <div class="content_top_box">
                        <div class="lunbo"
                            :style="`height:calc(${content_top_height}px - 5px - 8vh);`">
                            <el-carousel ref="carousel" :initial-index="currentSlideIndex" @change="carouselChange" :interval="10000" trigger="click" :height="`calc(${content_top_height}px - 5px - 8vh) !important`"
                                v-if="slideshowList.length > 0" indicator-position="none">
                                <el-carousel-item v-for="(item, index) in slideshowList" :key="index" :style="`width:100%;height:calc(${content_top_height}px - 5px - 8vh)`">
                                    <img :src="`${imgUrl}/${item.imgUrl}`" alt="" :style="`width:100%;height:calc(${content_top_height}px - 5px - 8vh)`"
                                        @click="slideshowClick(item)">
                                </el-carousel-item>
                            </el-carousel>
                             <div class="carousel-indicators">
                                <span 
                                    v-for="(item, index) in slideshowList" 
                                    :key="index" 
                                    :class="{ 'indicator-dot': true, 'active': index === currentSlideIndex }"
                                    @click="changeSlide(index)">
                                </span>
                            </div>
                        </div>
                        <div style="display: flex;align-items: center;justify-content: space-between;">
                            <span @click="scrollMenuLeft" class="left_arrows"><i
                                    class="el-icon-d-arrow-left"></i></span>
                            <el-menu :default-active="activeIndex"
                                :style="`width:calc(${content_top_width}px - 5px - 40px);`" class="el-menu-demo"
                                mode="horizontal" @select="handleSelect">
                                <div ref="menuContainer"
                                    style="overflow-x: auto;overflow-y: hidden;display: flex;align-items: center;border-right: 1px solid #f0eded !important;border-left: 1px solid #f0eded !important;">
                                    <recursive-menu :menu-list="classifyList"
                                        style="display: flex;align-items: center;"></recursive-menu>
                                </div>
                            </el-menu>
                            <span @click="scrollMenuRight" class="right_arrows"><i
                                    class="el-icon-d-arrow-right"></i></span>
                        </div>
                    </div>
                </div>
                <div class="content_right">
                    <div class="content_right_top" v-for="(item, index) in timeLimit" :key="index">
                        <div class="block block1">
                            <div class="content_right_left">
                                <span></span>
                                <h3>{{ item.title }}</h3>
                            </div>
                            <!-- <span class="see" @click="earlySee(item)">查看</span> -->
                        </div>
                        <ul @click="toWaringMenu(index)" style="cursor: pointer;">
                            <template>
                                <div v-for="(val, key) in item.children" :key="key"
                                    style="display: flex;align-items: center;flex:1">
                                    <li style="width: 100%;text-align: center;">
                                        <el-tooltip v-if="index" effect="dark" :content="val.toolTip" placement="top">
                                            <div slot="content" style="max-width: 300px; ">
                                                {{ val.toolTip }}
                                            </div>
                                            <p>{{ val.title }}<i class="el-icon-question"></i></p>
                                        </el-tooltip>
                                        <p v-else>{{ val.title }}</p>
                                        <p class="color30" v-if="val.title == '缺货率'">{{ val.num }} <i
                                                style="font-style: normal;color: #333;font-size: 0.8vw;">%</i></p>
                                        <p v-else-if="index == 1 && val.title != '缺货率'" class="color30">{{ val.num }} <i
                                                style="font-style: normal;color: #333;font-size: 0.8vw;">品规</i></p>
                                        <p v-else class="color30">{{ val.num }} <i
                                                style="font-style: normal;color: #333;font-size: 0.8vw;">条</i></p>
                                    </li>
                                    <el-divider v-if="key != 2" direction="vertical"
                                        class="direction_height"></el-divider>
                                </div>
                            </template>
                        </ul>
                    </div>
                </div>
            </div>
        </div>
        <!-- 公告通知列表 -->
        <el-dialog title="公告通知" :visible.sync="noticeObj.noticeFlag" :width="allDialogWidth">
            <div slot="title" class="dialog-title">
                <i v-if="showAll" class="el-icon-full-screen dialog_icon"
                    @click="allDialogWidth = '80%', showAll = !showAll"></i>
                <i v-else class="el-icon-copy-document dialog_icon"
                    @click="allDialogWidth = '500px', showAll = !showAll"></i>
            </div>
            <ul class="notice_frame">
                <li v-for="(item, index) in noticeList" :key="index">
                    <p>
                        <el-badge v-if="!item.isRead" is-dot class="item"><span @click="noticeItemClick(item)">{{
                            item.punTitle
                                }}</span></el-badge>
                        <span v-else @click="noticeItemClick(item)">{{ item.punTitle
                        }}</span>
                        <span class="state">状态:{{ getTaskStatus(item.punSendstate) }}</span>
                    </p>
                    <div v-html="item.punContent"></div>
                    <p>
                        <span>创建人：{{ item.createrName }}</span>
                        <span v-if="item.createTime" class="spanMargin">
                            &nbsp;&nbsp;{{ $common.getLocalTime(item.createTime, true) }}
                        </span>
                    </p>
                    <p>
                        <span v-if="item.punStarttime">开始时间：{{ $common.getLocalTime(item.punStarttime) }}</span>
                        <span v-if="item.punValiduntil">&nbsp;/&nbsp;结束时间：{{ $common.getLocalTime(item.punValiduntil)
                        }}</span>
                    </p>
                    <p>已查看：{{ item.readerName }}</p>
                </li>
            </ul>
        </el-dialog>
        <!-- 公告通知内容 -->
        <el-dialog :title="noticeObj.punTitle" :visible.sync="noticeObj.noticeItemFlag" :width="oneDialogWidth">
            <div slot="title" class="dialog-title">
                <i v-if="showOne" class="el-icon-full-screen dialog_icon"
                    @click="oneDialogWidth = '80%', showOne = !showOne"></i>
                <i v-else class="el-icon-copy-document dialog_icon"
                    @click="oneDialogWidth = '500px', showOne = !showOne"></i>
            </div>
            <div style="height: 500px;overflow: auto;" v-html="noticeObj.html"></div>
        </el-dialog>
        <!-- 预警查看 -->
        <el-dialog :title="earlyWarningObj.title" :visible.sync="earlyWarningObj.flag" width="80%">
            <u-table :data="earlyWarningObj.dataList" height="500" :row-height="20" row-key="index" use-virtual
                size="mini" :highlight-current-row="false" border style="width: 100%">
                <u-table-column align="center" v-for="(tableValye, tableKey) in earlyWarningObj.nameList"
                    :key="tableKey" :prop="tableValye.entityField" :label="tableValye.showField" show-overflow-tooltip
                    :min-width="tableValye.fieldWeight">
                </u-table-column>
            </u-table>
        </el-dialog>
        <!-- 待办对话款 -->
        <el-dialog center :title="todoListTitle" :visible.sync="showTodoList" width="80%">
            <el-table stripe :data="toDoDataList" height="500" :row-height="20" row-key="index" use-virtual size="mini"
                :highlight-current-row="false" border style="width:100%">
                <el-table-column align="center" v-for="(tableValye, tableKey) in toDoNameList" :key="tableKey"
                    :prop="tableValye.entityField" :sortable="tableValye.isSort" :label="tableValye.showField"
                    show-overflow-tooltip :min-width="tableValye.fieldWeight">
                    <template slot-scope="scope">
                        <el-tag size="mini" v-if="tableValye.fieldType == 'select'">
                            {{ $common.getIsGsp(tableValye.typeList, scope.row[tableValye.entityField]) }}</el-tag>
                        <span v-else-if="tableValye.fieldType == 'date'">
                            <span v-if="scope.row[tableValye.entityField]">
                                {{ $common.getLocalTime(scope.row[tableValye.entityField], true) }}
                            </span>
                        </span>
                        <span v-else-if="tableValye.fieldType == 'toDetail' && scope.row.taskMode == 1">
                            <a @click="lookDetail(scope.row)">{{
                                scope.row[tableValye.entityField] }}</a>
                        </span>
                        <span v-else-if="tableValye.fieldType == 'toDetail'">
                            <a @click="toDetail(scope.row[tableValye.entityField])">{{
                                scope.row[tableValye.entityField] }}</a>
                        </span>

                        <span v-else>
                            {{ scope.row[tableValye.entityField] }}
                        </span>
                    </template>
                </el-table-column>
                <el-table-column align="center" fixed="right" label="操作" :width="btnTitle == '审核' ? 140 : 80">
                    <template slot-scope="scope">
                        <el-button @click.native.prevent="dealInfo(scope.row)" type="text" size="small">
                            {{ btnTitle }}
                        </el-button>
                        <el-button v-if="btnTitle == '审核'" @click.native.prevent="dealInfo(scope.row, 1)" type="text"
                            size="small">
                            跳转
                        </el-button>
                    </template>
                </el-table-column>
            </el-table>
        </el-dialog>
        <processAuditAction ref="processAuditAction"></processAuditAction>
        <el-drawer :close-on-press-escape="true" :visible.sync="showStatus" :with-header="false"
            append-to-bodycustom-class="drawer_box" direction="ltr" size="100%">
            <flowInstanceApplyAction v-if="showStatus" ref="flowInstanceApplyAction" @drawerCancel="drawerCancel"
                :actionData="actionData">
            </flowInstanceApplyAction>
        </el-drawer>
    </div>
</template>

<script>
import * as echarts from 'echarts';
import datajs from './data.js'
import { EleResize } from '../assets/js/esresize';
import flowInstanceApplyAction from '@/components/flowInstanceApplyAction.vue'
import recursiveMenu from "./home/components/recursiveMenu.vue";
export default {
    components: {
        flowInstanceApplyAction,
        recursiveMenu
    },

    data() {
        return {
            imgUrl: "",
            showAll: true,
            allDialogWidth: "500px",
            showOne: true,
            oneDialogWidth: "500px",
            btnTitle: '',
            showTodoList: false,//待办对话款
            todoListTitle: '',//待办对话款
            toDoNameList: [],
            toDoDataList: [],
            time: new Date(),
            noticeList: [],
            noticeList1: [],
            userName: "",
            opmJob: "",
            userDep: "",
            height: 500,
            content_left_bottom: "200px",
            content_top_height: 100,
            content_top_width: 0,
            echartHeight: 0,
            backlogList: [
                {
                    title: "待审核",
                    num: 0,
                    icon: "el-icon-document"
                },
                {
                    title: "待办事项",
                    num: 0,
                    icon: "el-icon-tickets"
                },
                {
                    title: "跟踪事项",
                    num: 0,
                    icon: "el-icon-map-location"
                },
                {
                    title: "已完成",
                    num: 0,
                    icon: "el-icon-document-checked"
                },
            ],
            //预警
            earlyWarning: [],
            //超时
            timeoutList: Array(3).fill({ children: Array(5).fill({}) }),
            //效期、滞销预警
            timeLimit: [
                {
                    title: "效期预警",
                    children: []
                },
                {
                    title: "缺货分析",
                    children: [
                        {
                            title: "缺货率",
                            toolTip: `缺货率 = (日均销量*缺货期间-当前库存）/ 日均销量*缺货期间× 100%。日均销量=（${this.$moment(new Date().setDate(new Date().getDate() - 30)).format('YYYY-MM-DD')}~${this.$moment().format('YYYY-MM-DD')}）总销量/30天。缺货期间=30天。当前库存=在途库存+当前可销库存。`,
                            num: 0
                        },
                        {
                            toolTip: `缺货品规：缺货库存（日均销量*缺货期间-当前库存>0 的品种数）。日均销量=（${this.$moment(new Date().setDate(new Date().getDate() - 30)).format('YYYY-MM-DD')}~${this.$moment().format('YYYY-MM-DD')}）总销量/30天。缺货期间=30天。当前库存=在途库存+当前可销库存。`,
                            title: "缺货品规",
                            num: 0
                        },
                        {
                            title: "紧急缺货",
                            toolTip: '紧急缺货：近7日销售人员主动进行登记缺货品种数。',
                            num: 0
                        },
                    ]
                }
            ],
            //轮播
            slideshowList: [],
            currentSlideIndex:0,
            activeIndex: "",
            classifyList: [],
            noticeObj: {
                noticeFlag: false,//列表弹框
                noticeItemFlag: false,//内容弹框
                html: "",//内容
                punTitle: "",//标题
            },
            earlyWarningObj: {
                flag: false,
                title: "",
                nameList: [],
                dataList: [],
            },
            zxData: {
                number1: '',
                number2: '',
                number3: '',
                number4: ''
            },
            rotateZ: 0,
            showStatus: false,
            actionData: {},
            licenseWarnDataList: [],
            
        }
    },
    created() {
        this.imgUrl = window.global_config.BASE_IMG_URL
        this.queryAllNum()
        setInterval(() => {
            this.getMonthAllTask()
        }, 30 * 60 * 1000)
        this.homeQueryJxqCount()//近效期
        this.homeQueryQhCount()//缺货
        // this.homeQueryXqyjCount()//效期预警 - 移到initEarlyWarning中调用
        this.homeQueryOuttime()//超时
        this.queryZxCount()//滞销
        this.queryClassify()//轮播图分类
        this.slideshowQuery()
        setInterval(() => {
            this.getNoticeList()
            this.queryTaskNumber()//四大块
        }, 10 * 60 * 1000)
        this.timeflag();
        this.userName = JSON.parse(sessionStorage.getItem('userInfo')).opmName
        this.opmJob = JSON.parse(sessionStorage.getItem('userInfo')).opmJob
        this.userDep = sessionStorage.getItem('ormName')
    },
    methods: {
        carouselChange(index){
            this.currentSlideIndex=index
            
        },
        // 切换轮播图
        changeSlide(index) {
            this.currentSlideIndex = index;
            this.$refs.carousel.setActiveItem(index);
            // 注意：由于我们隐藏了默认的指示器，我们需要通过ref手动控制轮播图切换
            // 但这需要给el-carousel添加ref引用
        },
        scrollMenuLeft() {
            const container = this.$refs.menuContainer;
            container.scrollBy({
                left: -200,
                behavior: 'smooth'
            });
        },
        scrollMenuRight() {
            const container = this.$refs.menuContainer;
            container.scrollBy({
                left: 200,
                behavior: 'smooth'
            });
        },
        async queryClassify() {
            let responseData = await this.$http.carouseClassifyqueryList({})
            if (responseData.status == 200) {
                this.classifyList = this.handleJurisdiction(responseData.result)
            } else {
                this.$message({
                    message: responseData.message,
                    type: 'error'
                });
            }
        },
        // 权限处理
        handleJurisdiction(data, id = 0, lev = 0) {
            var son = []
            data.forEach((value, keys) => {
                if (value['parentId'] == id) {
                    value['id'] = value['id']
                    value['value'] = `${lev}-${value['id']}`
                    value['label'] = value['className']
                    value['contentUrl'] = value['contentUrl']
                    var list = this.handleJurisdiction(data, value['id'], lev + 1);
                    if (list.length >= 1) {
                        value['children'] = this.handleJurisdiction(data, value['id'], lev + 1);
                    }
                    son.push(value)

                }
            })
            return son;
        },
        handleSelect(val) {
            var str = val.split('-')[1]
            const item = {
                classId: str
            }
            this.$emit('paramToHome', '/catalogue', true, {
                item: item
            })
        },
        async slideshowQuery() {
            const res = await this.$http.carouselqueryList({ classId: "", state: 1 })
            if (res.status == 200) {
                if (res.result.length > 10) {
                    this.slideshowList = res.result
                } else {
                    this.slideshowList = res.result
                }
            }
        },
        slideshowClick(item) {
            this.$emit('paramToHome', '/homePage', true, {
                item: item
            })
        },
        getMonthAllTask() {
            this.$http.getQueryAllTask().then((res) => {
                if (res && res.status == 200) {
                    let data = JSON.parse(JSON.stringify(res.result))
                    this.$store.commit('updateWebIndexHeaderCount', data.desysAllotmenttaskReceive.length)//接收到的任务
                } else {
                    this.$store.commit('updateWebIndexHeaderCount', 0)
                }
            }).catch((rej) => {
                this.$message({
                    message: rej.message,
                    type: "error",
                })
            })
        },
        queryAllNum() {
            this.rotateZ = this.rotateZ + 180
            this.getNoticeList()
            this.queryTaskNumber()//四大块
            this.homeQueryJxqCount()//近效期
            this.homeQueryQhCount()//缺货
            // 如果earlyWarning已初始化，直接调用；否则等待initEarlyWarning调用
            if (this.earlyWarning && this.earlyWarning.length > 0) {
                this.homeQueryXqyjCount()//效期预警
            }
            this.homeQueryOuttime()//超时
            this.queryZxCount()//滞销
            this.getMonthAllTask()//
        },
        openBox() {
            this.getNoticeList()
            this.queryTaskNumber()//四大块
            this.userName = JSON.parse(sessionStorage.getItem('userInfo')).opmName
            this.opmJob = JSON.parse(sessionStorage.getItem('userInfo')).opmJob
            this.userDep = sessionStorage.getItem('ormName')
            this.$nextTick(() => {
                this.heightChange()
            })
        },
        drawerCancel() {
            this.showStatus = false
        },
        lookDetail(row) {
            this.queryDetails(row, true)
        },
        async queryDetails(row, flag) {
            const res = await this.$http.flowInstancequeryInfo({ ids: [row.businessId] })
            if (res.status = 200) {
                let responseData = await this.$http.flowDeinitqueryDeinitionById({ ids: [res.result.wfdId] });
                if (responseData && responseData.status == 200) {
                    this.actionData = {
                        cate: 4,
                        wfdId: row.businessId,
                        wfiId: res.result.wfiId,
                        wdfForm: responseData.result.wdfForm,
                        wfiContent: res.result.wfiContent,
                        wfdName: res.result.wfdName,
                        wfiRemark: res.result.wfiRemark,
                    }
                    if (flag) {
                        this.actionData.cate = 2
                    }
                    this.showStatus = true
                } else {
                    this.$message({
                        message: responseData.message,
                        type: "error",
                    });
                }

            }
        },
        async dealInfo(row, index = 0) {
            if (this.btnTitle == '跳转') {
                this.showTodoList = false
                this.$emit('paramToHome', row.targetPath)
            } else if (this.btnTitle == '审核') {
                if (index) {
                    this.showTodoList = false
                    this.$emit('paramToHome', row.targetPath)
                } else {
                    if (row.taskMode == 1) {
                        this.queryDetails(row)
                    } else {
                        console.log(row, 'row')
                        this.$refs["processAuditAction"].openBox(0, [row.businessId]);
                        this.$refs["processAuditAction"].dealTitle(row);
                    }

                }
            } else if (this.btnTitle == '查看进度') {
                if (row.taskMode == 1) {
                    this.queryDetails(row, true)
                } else {
                    this.$refs["processAuditAction"].openBox(1, row.businessId);

                }

            } else if (this.btnTitle == '查看') {
                this.$refs["processAuditAction"].openBox(1, row.businessId);
            }
        },
        // 点击穿透字段 传参单号
        toDetail(orderId) {
            if (orderId) {
                // 设置为true 打开穿透组件首页
                var isPenetrate = true;
                // 设置缓存 存入点击单号
                this.resetSetItem("penetrateOrderId", orderId);
                // 与父级跨域通信 传递isPenetrate参数
                window.parent.postMessage(
                    {
                        //向窗口发送MessageEvent消息
                        cmd: "returnFormJson",
                        params: { isPenetrate }, //参数
                    },
                    "*"
                );
            }
        },
        toWaringMenu(index) {
            if (index) {
                this.$emit('paramToHome', '/purchasePlan')
            } else {
                this.$emit('paramToHome', '/validityAnomalyWarning')
            }
        },
        //时间
        timeflag() {
            setTimeout(() => {
                this.time = new Date();
                this.timeflag();
            }, 1000);
        },
        //
        timeWeek(val) {
            if (val == 'Monday') {
                return "星期一"
            } else if (val == 'Tuesday') {
                return "星期二"
            } else if (val == 'Tuesday') {
                return "星期二"
            } else if (val == 'Wednesday') {
                return "星期三"
            } else if (val == 'Thursday') {
                return "星期四"
            } else if (val == 'Friday') {
                return "星期五"
            } else if (val == 'Saturday') {
                return "星期六"
            } else if (val == 'Sunday') {
                return "星期日"
            }
        },
        //查询头部公告信息
        getNoticeList() {
            this.$http.getQueryShowNotices().then((res) => {
                if (res && res.status == 200) {
                    this.noticeList = res.result
                    this.noticeList1 = []
                    this.noticeList.forEach((item, index) => {
                        if (index <= 5) {
                            this.noticeList1.push(item)
                        }
                    })
                } else {
                    this.$message({
                        message: res.message,
                        type: "error",
                    })
                }
            }).catch((rej) => {
                this.$message({
                    message: rej.message,
                    type: "error",
                })
            })
        },
        //点击待审核等
        clickTask(index) {
            switch (index) {
                case 0:
                    this.btnTitle = '审核'
                    this.todoListTitle = '待审核列表'
                    this.toDoNameList = datajs.toAuditNameList

                    this.getDataList()
                    break;
                case 1://待办
                    this.btnTitle = '跳转'
                    this.todoListTitle = '待办列表'
                    this.toDoNameList = datajs.toDoNameList
                    this.getDataList()
                    break;
                case 2:
                    this.btnTitle = '查看进度'
                    this.todoListTitle = '跟踪任务列表'
                    this.toDoNameList = datajs.toSeeNameList
                    this.getDataList()
                    break;
                case 3:
                    this.btnTitle = '查看'
                    this.todoListTitle = '已完成列表'
                    this.toDoNameList = datajs.doneNameList
                    this.getDataList()
                    break;
                default:
                    break;
            }
        },
        clickWarning(index) {
            this.$emit('paramToHome', this.earlyWarning[index].url)
        },
        //查询我的待办的总数量
        queryTaskNumber() {
            this.$http.homeQueryTaskNumber().then((res) => {
                if (res && res.status == 200) {
                    this.backlogList[0].num = res.result.auditTask || 0
                    this.backlogList[1].num = res.result.needTask || 0
                    this.backlogList[2].num = res.result.taskTracking || 0
                    this.backlogList[3].num = res.result.finishTask || 0
                } else {
                    this.$message({
                        message: res.message,
                        type: "error",
                    })
                }
            }).catch((rej) => {
                this.$message({
                    message: rej.message,
                    type: "error",
                })
            })
        },
        //查询滞销数量
        queryZxCount() {
            this.$http.homeQueryZxCount().then((res) => {
                if (res && res.status == 200) {
                    for (let key in this.zxData) {
                        this.zxData[key] = res.result[key]
                    }
                    // this.getEchart()
                } else {
                    this.$message({
                        message: res.message,
                        type: "error",
                    })
                }
            }).catch((rej) => {
                this.$message({
                    message: rej.message,
                    type: "error",
                })
            })
        },
        //查询右侧缺货分析
        homeQueryQhCount() {
            this.$http.homeQueryQhCount().then((res) => {
                if (res && res.status == 200) {
                    this.timeLimit[1].children[0].num = res.result.qhl || 0
                    this.timeLimit[1].children[1].num = res.result.hppg || 0
                    this.timeLimit[1].children[2].num = res.result.jjqh || 0
                } else {
                    this.$message({
                        message: res.message,
                        type: "error",
                    })
                }
            }).catch((rej) => {
                this.$message({
                    message: rej.message,
                    type: "error",
                })
            })
        },
        //查询右侧预警总数量
        homeQueryJxqCount() {
            this.$http.homeQueryJxqCount().then((res) => {
                if (res && res.status == 200) {
                    // 检查children数组是否已初始化
                    if (this.timeLimit[0].children && this.timeLimit[0].children.length >= 3) {
                        this.timeLimit[0].children[0].num = res.result.thirtyDay
                        this.timeLimit[0].children[1].num = res.result.ninetyDay
                        this.timeLimit[0].children[2].num = res.result.hundredTask
                    }
                } else {
                    this.$message({
                        message: res.message,
                        type: "error",
                    })
                }
            }).catch((rej) => {
                this.$message({
                    message: rej.message,
                    type: "error",
                })
            })
        },
        //查询效期预警
        homeQueryXqyjCount() {
            this.$http.homeQueryXqyjCount().then((res) => {
                if (res && res.status == 200) {
                    this.earlyWarning = this.earlyWarning.map(item => {
                        item.num = res.result[item.prop]
                        return item
                    })
                } else {
                    this.$message({
                        message: res.message,
                        type: "error",
                    })
                }
            }).catch((rej) => {
                this.$message({
                    message: rej.message,
                    type: "error",
                })
            })
        },
        //查询效期预警
        homeQueryOuttime() {
            this.$http.homeQueryOuttime().then((res) => {
                if (res && res.status == 200) {
                    console.log(res);
                    const chunkedArray = [];

                    for (let i = 0; i < res.result.length; i += 5) {
                        const chunk = {
                            children: res.result.slice(i, i + 5)
                        };
                        chunkedArray.push(chunk);
                    }

                    this.timeoutList = chunkedArray
                    this.$nextTick(() => {
                        setTimeout(() => {
                            this.heightChange()
                        }, 500)
                    })
                } else {
                    this.$message({
                        message: res.message,
                        type: "error",
                    })
                }
            }).catch((rej) => {
                this.$message({
                    message: rej.message,
                    type: "error",
                })
            })
        },
        getDataList() {
            let url = ''
            if (this.btnTitle == '跳转') {
                url = 'homeQueryMyNeed'
            } else if (this.btnTitle == '审核') {
                url = 'homeQueryAuditTask'
            } else if (this.btnTitle == '查看进度') {
                url = 'homeQueryMyTracking'
            } else if (this.btnTitle == '查看') {
                url = 'homeQueryFinish'
            }
            this.queryTaskNumber()
            this.$http[url]().then((res) => {
                if (res && res.status == 200) {
                    this.toDoDataList = res.result
                    this.showTodoList = true

                } else {
                    this.$message({
                        message: res.message,
                        type: "error",
                    })
                }
            }).catch((rej) => {
                this.$message({
                    message: rej.message,
                    type: "error",
                })
            })
        },
        heightChange() {
            var height = document.documentElement.clientHeight
            var headerHeight = document.documentElement.querySelector('.index_top_box').clientHeight
            var topHeight = document.documentElement.querySelector('.el-tabs__header').clientHeight
            this.height = height - headerHeight - topHeight
            var top_box = document.documentElement.querySelector('.top_box').clientHeight
            var content_left_top = document.documentElement.querySelector('.content_left_top').clientHeight
            var content_right = 0
            var content_top_box = 0
            if (document.documentElement.querySelector('.content_right')) {
                content_right = document.documentElement.querySelector('.content_right').clientHeight
            }
            if (document.documentElement.querySelector('.content_top')) {
                content_top_box = document.documentElement.querySelector('.content_top').clientWidth
            }
            this.content_left_bottom = this.height - top_box - content_left_top
            this.content_top_height = this.height - content_right
            if (this.content_top_height <= content_top_box) {
                this.content_top_width = this.content_top_height - 10
            } else {
                this.content_top_width = content_top_box
            }
        },
        getEchart() {
            var chartDom = document.getElementById('deliveryChart');
            var myChart = echarts.init(chartDom);
            var option;

            option = {
                title: {
                    left: 'center',
                    bottom: 0,
                    text: '滞销库存品规占比分析',

                },
                tooltip: {
                    trigger: 'item',
                    formatter: '滞销{b}天<br>{c}个品规,占比{d}%'
                },
                legend: {
                    orient: 'vertical',
                    left: 'right'
                },
                color: ['#95df6f', '#7ebefd', '#fac858', '#ff7070'],
                series: [
                    {
                        name: '滞销分析',
                        type: 'pie',
                        radius: ['40%', '70%'],
                        label: { show: true, formatter: '{c}' },
                        labelLine: { show: true },
                        data: [
                            { value: this.zxData.number1, name: '0~30' },
                            { value: this.zxData.number2, name: '31~60' },
                            { value: this.zxData.number3, name: '61~90' },
                            { value: this.zxData.number4, name: '≥90' },
                        ],
                        emphasis: {
                            itemStyle: {
                                shadowBlur: 10,
                                shadowOffsetX: 0,
                                shadowColor: 'rgba(0, 0, 0, 0.5)'
                            }
                        }
                    }
                ]
            };

            option && myChart.setOption(option);
            let listener = function () {
                myChart && myChart.resize();
            };
            EleResize.on(document.getElementById('deliveryChart'), listener);
        },
        getTimeState() {
            // 获取当前时间
            let timeNow = new Date();
            // 获取当前小时
            let hours = timeNow.getHours();
            // 设置默认文字
            let state = ``;
            // 判断当前时间段
            if (hours >= 0 && hours <= 10) {
                state = `早上好`;
            } else if (hours > 10 && hours <= 14) {
                state = `中午好`;
            } else if (hours > 14 && hours <= 18) {
                state = `下午好`;
            } else if (hours > 18 && hours <= 24) {
                state = `晚上好`;
            }
            return state;
        },
        //公告列表
        noticeClick() {
            this.noticeObj.noticeFlag = true
        },
        noticeItemClick(item) {
            this.noticeObj.noticeItemFlag = true
            this.noticeObj.html = item.punContent
            this.noticeObj.punTitle = item.punTitle
            //调接口改变公告读取状态
            this.$http['homeAddReader']({ ids: [item.punIndex] }).then((res) => {
                if (res && res.status == 200) {
                    this.getNoticeList()
                }
            })
        },
        //获取状态0.初始1.关闭（发起人）2.完成3.拒绝（接收人）
        getTaskStatus(num) {
            if (num == 0) {
                return '停用'
            } else if (num == 1) {
                return '启用'
            }
        },
        //预警查看
        earlySee(val) {
            this.$emit('paramToHome', val)
        },
        // 初始化预警数据，使用动态天数
        initEarlyWarning() {
            if (this.licenseWarnDataList && this.licenseWarnDataList.length > 0) {
                const warnData = this.licenseWarnDataList[0];

                // 初始化证照预警数据
                this.earlyWarning = [
                    {
                        title: "商品证照临期",
                        num: 0,
                        url: '/busGoodsWarnList',
                        prop: 'goodzzsl',
                        content: `商品证照在<i style="font-style: normal;color: #e53434;">${warnData.goodsNum || 90}天</i>内到期数量`,
                    },
                    {
                        title: "供应商证照临期",
                        prop: 'supzzsl',
                        url: '/suplicencelWarnList',
                        num: 0,
                        content: `供应商证照在<i style="font-style: normal;color: #e53434;">${warnData.supplierNum || 90}天</i>内到期数量`,
                    },
                    {
                        title: "客户证照临期",
                        prop: 'cuszzsl',
                        num: 0,
                        url: '/cuslicencelWarnList',
                        content: `客户证照在<i style="font-style: normal;color: #e53434;">${warnData.customerNum || 90}天</i>内到期数量`,
                    },
                    {
                        title: "委托书临期",
                        prop: 'saleszzsl',
                        num: 0,
                        url: '/salesLicencelWarnList',
                        content: `委托书在<i style="font-style: normal;color: #e53434;">${warnData.salesNum || 90}天</i>内到期数量`,
                    },
                    {
                        title: "进价浮动异常",
                        prop: 'gyzhjj',
                        num: 0,
                        toolTip: '近1个月内，采购进价与最后进价对比，浮动超过5%的采购预警，公式:含税价格-最后进价>±5%。',
                        url: '/highLowestList',
                        content: '1月内进价浮动超<i style="font-style: normal;color: #e53434;">5%</i>采购条数',
                    },
                    {
                        title: "采购短期内退货",
                        prop: 'cgdqnth',
                        num: 0,
                        url: '/shortTermReturnList',
                        content: '采购入库后<i style="font-style: normal;color: #e53434;">7日</i>内退货条目数',
                    },
                    {
                        title: "销售短期内退货",
                        prop: 'dqnth',
                        num: 0,
                        url: '/salesShortTermReturn',
                        content: '销售出库后<i style="font-style: normal;color: #e53434;">7日</i>内退货条目数',
                    },
                    {
                        title: "客户信贷临期",
                        prop: 'xdyc',
                        num: 0,
                        url: '/creditPeriodErrorList',
                        content: '客户信贷<i style="font-style: normal;color: #e53434;">7日</i>内到期客户数量',
                    },
                ];

                // 初始化近效期预警数据，使用动态天数
                this.timeLimit[0].children = [
                    {
                        title: `近效期${warnData.expiNum1 || 30}天`,
                        num: 0
                    },
                    {
                        title: `近效期${warnData.expiNum2 || 90}天`,
                        num: 0
                    },
                    {
                        title: `近效期${warnData.expiNum3 || 180}天`,
                        num: 0
                    },
                ];

                // 初始化完成后，立即获取预警数量
                this.homeQueryXqyjCount();
                this.homeQueryJxqCount(); // 获取近效期预警数量
            }
        },
    },
    mounted() {
        // setTimeout(() => {
        //     this.heightChange()
        // }, 300)
        window.addEventListener('resize', this.heightChange);
        this.$nextTick(() => {
            // this.getEchart()
            setTimeout(() => {
                this.heightChange()
            }, 500)
        })
        this.$http.getLicenseWarnQueryAll({

        }).then(res => {
            console.log(res, 'res111')
            this.licenseWarnDataList = res.result
            console.log(this.licenseWarnDataList[0].goodsNum, 'res111')
            // 初始化预警数据，使用动态天数
            this.initEarlyWarning()
        })
    },
    beforeDestroy() {
        // 移除绑定的listenResizeFn事件监听
        window.removeEventListener("resize", this.heightChange);
    }
}
</script>

<style scoped>
    .carousel-indicators {
    position: absolute;
    bottom: 10vh;
    left: 50%;
    transform: translateX(-50%);
    display: flex;
    z-index: 10;
}

.indicator-dot {
    display: inline-block;
    width: 10px;
    height: 10px;
    border-radius: 50%;
    background-color: #ffffff;
    margin: 0 5px;
    cursor: pointer;
    transition: background-color 0.3s;
}

.indicator-dot.active {
    background-color: #409eff;
}
.dialog-title {
    position: relative;
    width: 100%;
}

.dialog_icon {
    position: absolute;
    font-size: 12px;
    right: 16px;
    top: -6px;
}

ul {
    list-style: none;
}

.el-tooltip {
    max-width: 300px;
    /* 限制最大宽度为300px */
}

.home {
    height: calc(100vh - 80px);
    width: 100vw;
    background-color: #f5f5f5;
    padding: 0 0.5vw;
    overflow: auto;
}

.home::-webkit-scrollbar {
    /*滚动条整体样式*/
    width: 0.2vw;
    /*高宽分别对应横竖滚动条的尺寸*/
    height: 1vh;
}

.home::-webkit-scrollbar-thumb {
    /*滚动条里面小方块*/
    border-radius: 10px;
    box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
    background: #c1c1c1;
}

.home::-webkit-scrollbar-track {
    /*滚动条里面轨道*/
    box-shadow: inset 0 0 5px rgba(255, 255, 255, 1);
    border-radius: 10px;
    background: #f1f1f1;
}

.top_box {
    /* height: 200px; */
    height: 26.3vh;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding-bottom: 0.8vh;
    padding-top: 0.5vh;
}

.bottom_box {
    display: flex;
    justify-content: space-between;
}

/* 个人信息、待办 */
.header {
    width: 73.5vw;
    /* height: 100%; */
    /* background-color: #fff; */
}

.header_top {
    padding: 1vh 1.5vw;
    display: flex;
    align-items: center;
    justify-content: space-between;
    background-color: #fff;
}

.header_top_left {
    display: flex;
    align-items: center;
    justify-content: space-between;
}

.header_top_right {
    display: flex;
    align-items: center;
    font-size: 1vw;
    /* color: #409eff; */
}

.header_top_right .time {
    font-size: 2.2vw;
    margin-right: 1vw;
}

.header_top_right .week {
    font-size: 0.9vw;
}

.header_top_left img {
    height: 6.5vh;
}

.header_top_left .user {
    padding: 0 0.6vw;
}

.header_top_left .user h5 {
    color: #333;
    font-size: 0.9vw;
    margin-bottom: 0.7vh;
}

.header_top_left .user p:nth-child(2) {
    font-size: 0.75vw;
    color: #6d6d6d;
}

.header_bottom {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-top: 1vh;
}

.header_bottom li {
    width: 18vw;
    height: 15.5vh;
    background-color: #fff;
    display: flex;
    align-items: center;
    justify-content: space-between;
    border-radius: 3px;
    cursor: pointer;
}

.header_bottom li div {
    padding: 2vh 2vw;
    width: 60%;
}

.header_bottom li .icons {
    text-align: center;
    width: 40%;
    flex-shrink: 0;
    font-size: 3vw;
    color: #fff;
}

.header_bottom li p {
    color: #fff;
}

.header_bottom li p:nth-child(1) {
    font-size: 1.5vw;
    margin-bottom: 0.5vh;
}

.header_bottom li p:nth-child(2) {
    font-size: 2.2vw;
    /* font-weight: 700; */
}

.header_bottom li:nth-child(1) {
    background-color: #e9b96b;
}

.header_bottom li:nth-child(2) {
    background-color: #fc8e8e;
}

.header_bottom li:nth-child(3) {
    background-color: #7ebefd;
}

.header_bottom li:nth-child(4) {
    background-color: #95df6f;
}

/* 公告 */
.notice {
    width: 25vw;
    height: 100%;
    font-size: 0.75vw;
    background-color: #fff;
    padding: 0 1vw;
}

.notice_top {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 1vh 0;
    border-bottom: 1px solid #e8e8e8;
}

.notice_top .block {
    padding: 0;
}

.notice_top span {
    color: #409eff;
}

.notice_top span:hover,
.notice ul li:hover {
    cursor: pointer;
    color: #409eff;
}

.notice ul li {
    display: flex;
    align-items: center;
    /* justify-content: space-between; */
    border-bottom: 1px solid #e8e8e8;
    padding: 0.7vh 0 0.4vh 0;
}

.notice ul li p {
    position: relative;
    margin-right: 0.5vh;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    padding-left: 0.5vw;
}

.notice .item {
    position: absolute;
    left: 0;
    top: 0;
}

.notice ul li span {
    flex-shrink: 0;
}

/* 左下层 */
.content_left {
    width: 73.5vw;
    height: 100%;
}

/* 右下层 */
.content_right {
    width: 25vw;
    height: 100%;
}

.content_top {
    padding-bottom: 0.5vw;
}

/* 轮播图 */
.content_top_box {
    background-color: #ffffff;
    width: 100%;
    height: 100%;
    position: relative;
}

/* 系统预警 */
.content_left_top {
    padding: 1vh 0;
    background-color: #fff;
    padding-bottom: 0;
}

.content_left_top ul {
    display: flex;
    align-items: center;
    justify-content: space-between;
    flex-wrap: wrap;
}

.content_left_top ul li {
    width: 17.6vw;
    padding: 1.5vh 1.5vw;
    margin-bottom: 1vh;
    background-color: #ffffff;
}

.direction_height {
    height: 5vh;
}

::v-deep .el-divider--vertical {
    margin: 0;
}

.content_left_top ul li .title_name {
    font-size: 0.9vw;
    display: flex;
    align-items: center;
    justify-content: space-between;
}

.content_left_top ul li .title_name span:nth-child(2) {
    font-size: 0.75vw;
    color: #409eff;
    cursor: pointer;
    font-weight: 500;
}

.content_left_top ul li .num {
    font-size: 1.2vw;
    margin: 0.8vh 0;
}

.content_left_top ul li .rate {
    font-size: 0.65vw;
    display: flex;
    align-items: center;
}

.content_left_top ul li .rate span {
    flex-shrink: 0;
    color: #767676;
}

/* 超时预警 */
.content_left_bottom {
    min-height: 100px;
    width: 100%;
    padding-top: 1vh;
    padding-bottom: 1vh;
}

/* .content_left_bottom .block {
    background-color: #f6f6f7;
    padding: 1vh 1vw;
    border: 0.1vw solid #e8e8e8;
}
.content_left_bottom ul {
    display: flex;
    align-items: center;
    justify-content: space-between;
    flex-wrap: wrap;
    border-right: 0.1vw solid #e8e8e8;
    border-left: 0.1vw solid #e8e8e8;
}
.content_left_bottom ul li {
    padding: 1vh 1.5vw;
    width: 24.6vw;
    font-weight: 600;
    font-size: 0.9vw;
    background-color: #fff;
    border-right: 0.1vw solid #e8e8e8;
    border-bottom: 0.1vw solid #e8e8e8;
    display: flex;
    align-items: center;
    justify-content: space-between;
}
.content_left_bottom ul li:nth-child(3n) {
    border-right: none;
}
.content_left_bottom ul li span:nth-child(1) {
    font-size: 0.8vw;
}
.content_left_bottom ul li span:nth-child(2) {
    color: #409eff;
} */
/* 左下层--效期预警、滞销预警 */
.content_right_top {
    padding-bottom: 1.01vh;
}

::v-deep .el-table__header tr th {
    background-color: #409eff;
    /* 蓝色背景 */
    opacity: 0.8;
    color: #fff;
    /* 字体颜色，根据需要调整 */
}

.content_right_top .block {
    background-color: #fff;
    padding: 1vh 1vw;
}

.content_right_top ul {
    background-color: #fff;
    display: flex;
    align-items: center;
    justify-content: space-between;
}

.content_right_top ul li {
    font-size: 0.9vw;
    padding: 1.31vh 1vw;
}

.content_right_top ul li p:nth-child(2) {
    font-size: 1.4vw;
    padding-top: 1.4vh;
}

.color30 {
    color: #ff0000;
}

.color90 {
    color: #fec575;
}

.color180 {
    color: #888888;
}

/* 图表 */
.content_right_bottom .block {
    background-color: #fff;
    padding-top: 1vh;
}

.top_chart {
    background-color: #fff;
}

.block {
    font-size: 0.8vw;
    display: flex;
    align-items: center;
    padding: 0 1vw;
}

.block span:nth-child(1) {
    display: inline-block;
    height: 100%;
    width: 3px;
    height: 2vh;
    background-color: #409eff;
    margin-right: 0.3vw;
}

.block h4 {
    font-size: 0.9vw;
    letter-spacing: 2px;
}

.block1 .content_right_left {
    display: flex;
    align-items: center;
}

.block1 {
    justify-content: space-between;
}

.block1 .see {
    cursor: pointer;
    color: #409eff;
}
</style>
<style scoped>
table {
    width: 33%;
    border-collapse: collapse;
    text-align: left;
    border-color: #e5e5e5;
}

td {
    background-color: #fff;
}

th {
    background-color: #9ac3ec;
    color: #fff;
}

td,
th {
    padding: 1vh 1vw;

    font-size: 0.9vw;
}

tr th {
    text-align: center;
}

.content_left_bottom td {
    text-align: center;
}

.content_left_bottom td span {
    /* color: #409eff; */
    cursor: pointer;
    /* border-bottom: 0.1vh solid #409eff; */
}

.content_left_bottom td span:hover {
    color: #409eff;
}
</style>
<style scoped>
.notice_frame {
    height: 500px;
    overflow: auto;
}

.notice_frame li {
    border: 1px solid #e5e5e5;
}

.notice_frame li p:nth-child(1) {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 5px 10px;
    border-bottom: 1px solid #e5e5e5;
    background-color: #dcdcdc;
}

.notice_frame li p:nth-child(1) .item:hover {
    cursor: pointer;
    color: #409eff;
}

.notice_frame .state {
    color: #409eff;
}

.notice_frame li p:nth-child(2) {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 5px 10px;
    border-bottom: 1px solid #e5e5e5;
    min-height: 100px;
}

.notice_frame li p:nth-child(3) {
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    padding: 5px 10px;
}

.notice_frame li p:nth-child(4) {
    display: flex;
    align-items: center;
    padding: 0 10px;
}

.notice_frame li p:nth-child(5) {
    display: flex;
    align-items: center;
    padding: 0 10px;
}

.notice_frame li p:last-child {
    padding-bottom: 5px;
}

/* 自定义滚动条样式 */
::-webkit-scrollbar {
    width: 6px;
    height: 6px;
}

::-webkit-scrollbar-track {
    background: #f1f1f1;
    border-radius: 10px;
}

::-webkit-scrollbar-thumb {
    background: #c1c1c1;
    border-radius: 10px;
}

::-webkit-scrollbar-thumb:hover {
    background: #a8a8a8;
}

/* 菜单容器滚动条 */
.el-menu-demo ::-webkit-scrollbar {
    height: 6px;
}

.el-menu-demo ::-webkit-scrollbar-track {
    background: #f1f1f1;
    border-radius: 3px;
}

.el-menu-demo ::-webkit-scrollbar-thumb {
    background: #c1c1c1;
    border-radius: 3px;
}

.el-menu-demo ::-webkit-scrollbar-thumb:hover {
    background: #a8a8a8;
}

.right_arrows,
.left_arrows {
    display: block;
    height: 6.5vh;
    width: 20px;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    background-color: #fff;
    font-size: 0.9vw;
}

.right_arrows:hover,
.left_arrows:hover {
    color: #409eff;
}
::v-deep .el-menu-demo{
    height: 6.5vh;
}
</style>